import { ModalProvider } from "../../../Modal/Modal";
import {
  TableBody,
  TableHead,
  TableRoot,
  //   TableRow,
} from "../../../Table/TableBasic";
import OpretNyButtonBlock from "../../person/id/OpretNyButtonBlock";
import DocumentIcon from "../../../icons/DocumentIcon";
import { useReports } from "../../../../hooks/useQueries";
import { DropdownItemIcon } from "../../../dropdown/Dropdown";
import ReportIcon from "../../../icons/ReportIcon";
import { ReportLink } from "@/components/ReportLink";

export default function Rapporter() {
  const { reports: allreports } = useReports();
  const reports = allreports?.filter((r) => r.uiPath === "aika/web/system");
  return (
    <div className="container">
      <h3 className="d-flex gap-2 align-items-center">
        <span className="c-theme-icon c-theme-icon--defaultSize text-primary bg-primary-light">
          <DocumentIcon width={17} />
        </span>
        <span>Rapporter</span>
      </h3>
      <div className="table-responsive">
        <ModalProvider>
          <TableRoot className="table--clear-empty-columns">
            <TableHead>
              <>
                <th>Titel</th>
                <th>Mimetype</th>
                <th></th>
              </>
            </TableHead>
            <TableBody>
              {reports &&
                reports.map((report) => {
                  return (
                    <tr key={report.id}>
                      <td>{report.title}</td>
                      <td>{report.mediaType}</td>
                      <td className="edit-column">
                        <ReportLink
                          url={report.url}
                          className="btn btn--action "
                        >
                          <DropdownItemIcon>
                            <ReportIcon />
                          </DropdownItemIcon>
                          <span>Hent</span>
                        </ReportLink>
                      </td>
                      <td></td>
                    </tr>
                  );
                })}
            </TableBody>
          </TableRoot>
          <OpretNyButtonBlock />
        </ModalProvider>
      </div>
    </div>
  );
}
